import { render, staticRenderFns } from "./NotificationsItemWithAction.vue?vue&type=template&id=8970a442&scoped=true"
import script from "./NotificationsItemWithAction.vue?vue&type=script&lang=js"
export * from "./NotificationsItemWithAction.vue?vue&type=script&lang=js"
import style0 from "./NotificationsItemWithAction.vue?vue&type=style&index=0&id=8970a442&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8970a442",
  null
  
)

export default component.exports